export default __webpack_public_path__ + "static/social-share-c472568d3494a8033797a276b849f64c.png";